<template>
  <Container class="section" :class="'align-' + align">
    <div class="row">
      <div
        class="col-lg-6 mb-4 mb-lg-0"
        :class="[align == 'right' ? 'order-0 order-lg-1' : '']"
      >
        <img v-lazy="img" :alt="title" class="img-fluid" />
      </div>
      <div
        class="col-lg-6 d-flex align-items-center"
        :class="[align == 'right' ? 'order-1 order-lg-0' : '']"
      >
        <div class="p-3">
          <h3 class="title" v-text="title"></h3>
          <div class="content">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    img: {
      type: String,
    },
    align: {
      type: String,
      default: "left",
    },
  },
};
</script>
<style lang="scss" scoped>
.section {
  padding: 3rem 0;
  @media (max-width: 576px) {
    padding: 2rem 0;
  }

  &.align-left {
    background: var(--color-light);
  }
}

.img-fluid {
  width: 100%;
  max-height: 540px;
  object-fit: cover;
  border-radius: var(--border-radius-more);
  box-shadow: var(--box-shadow-lift);
}

.title {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--dark);
  margin-bottom: 1.4rem;

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }

  @media (max-width: 576px) {
    font-size: 1.8rem;
  }
}
</style>